function ConvertStringToBoolean(value) {
  return value === "true" ? true : false;
}

function ConvertBooleanToString(value) {
  return value ? "true" : "false";
}

function ConvertBooleanToYesNo(value) {
  if(value === true){
    return 'yes';
  }
  if(value === false){
    return 'no';
  }
  return '';
}

function ConvertYesNoToBoolean(value) {
  if(value.toLowerCase() === 'yes'){
    return true;
  }
  if(value.toLowerCase() === 'no'){
    return false;
  }
  return null;
}

export { ConvertStringToBoolean, ConvertBooleanToString, ConvertBooleanToYesNo, ConvertYesNoToBoolean };


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/ConvertBoolean.js